module.exports = __webpack_public_path__ + "img/italian-dressing.130f3466.jpg";